import { render, staticRenderFns } from "./ProductServices.vue?vue&type=template&id=49383674"
import script from "./ProductServices.vue?vue&type=script&lang=js"
export * from "./ProductServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports